<template>
  <div id="page-user-edit">
    <vx-card v-if="operation_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <template>
            <div id="user-edit-tab-info">
              <!-- Content Row -->
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mt-4">
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>Internal ID #&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      </div>
                    </template>

                    <vs-input v-model="operation_data.id" disabled size="default" />
                  </vx-input-group>

                  <vx-input-group v-if="operation_data.sumal_aviz_nr" class="mt-4">
                    <template slot="prepend">
                      <div class="prepend-text bg-danger">
                        <span>AVIZ No
                          #&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      </div>
                    </template>

                    <vs-input v-model="operation_data.sumal_aviz_nr" disabled size="default" />
                  </vx-input-group>
                  <vx-input-group class="mt-4" v-if="!operation_data.sumal_aviz_nr">
                    <template slot="prepend">
                      <div class="prepend-text bg-danger">
                        <span>APV
                          No&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      </div>
                    </template>

                    <vs-input v-model="operation_data.apv_no" size="default" />
                  </vx-input-group>


                  <vx-input-group class="mt-4">
                    <template slot="prepend">
                      <div class="prepend-text bg-warning">
                        <span v-if="operation_data.apv_no">Contract
                          No&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <span v-else>Invoice
                          No&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      </div>
                    </template>

                    <vs-input v-model="operation_data.invoice_no" size="default" />
                  </vx-input-group>

                  <vx-input-group v-if="operation_data.apv_no" class="mt-4">
                    <template slot="prepend">
                      <div class="prepend-text bg-warning">
                        <span>Partida&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      </div>
                    </template>

                    <vs-input v-model="operation_data.partida" size="default" />
                  </vx-input-group>

                  <!--<vx-input-group v-if="operation_data.apv_no" class="mt-4">
                    <template slot="prepend">
                      <div class="prepend-text bg-warning">
                        <span>Guarantee (RON)</span>
                      </div>
                    </template>

                    <vs-input v-model="operation_data.apv_guarantee" size="default" v-validate="'decimal'" />
                  </vx-input-group>
                -->

                  <div class="w-full  mt-4" v-if="operation_data.apv_no">
                    <div class="vx-col md:w-3/12 w-full">
                      <span class="w-full" style="font-size:85%">
                        &nbsp;Private APV
                        <vs-switch class="w-full mt-0" color="green" icon-pack="feather" vs-icon-on="icon-yes"
                          vs-icon-off="icon-no" v-model="operation_data.isapvprivate">
                          <span slot="on">PRIVATE</span>
                          <span slot="off">PUBLIC</span>
                        </vs-switch>
                      </span>
                    </div>
                  </div>

                  <div class="w-full  mt-4" v-if="operation_data.apv_no">
                    <div class="vx-col md:w-3/12 w-full">
                      <span class="w-full" style="font-size:85%">
                        &nbsp;Harvesting Status
                        <vs-switch class="w-full mt-0" color="green" icon-pack="feather" vs-icon-on="icon-yes"
                          vs-icon-off="icon-no" v-model="operation_data.isharvestingover">
                          <span slot="on">OVER</span>
                          <span slot="off">ONGOING</span>
                        </vs-switch>
                      </span>
                    </div>


                  </div>

                  <div class="w-full mt-4" v-if="!operation_data.apv_no">
                    <vs-input label="Weight (t)" v-model="operation_data.transport_tonaj" v-validate="'decimal'"
                      class="w-full" name="weight" />
                    <span class="text-danger text-sm" v-show="errors.has('weight')">{{
                      errors.first("weight")
                    }}</span>
                  </div>
                  <div class="w-full mt-4">
                    <p class="w-full mt-4" style="font-size:85%" v-if="!operation_data.apv_no">
                      &nbsp;Reception Date
                      <datepicker :inline="false" v-model="operation_data.date"></datepicker>
                    </p>
                    <p class="w-full mt-4" style="font-size:85%" v-else>
                      &nbsp;APV Date
                      <datepicker :inline="false" v-model="operation_data.date"></datepicker>
                    </p>
                  </div>

                  <div class="w-full mt-4">
                    <vs-textarea class="w-full mt-10" counter="200" label="Internal Note"
                      :counter-danger.sync="counterDanger" v-model="operation_data.mail_top" />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="w-full mt-0">
                    <div style="font-size:85%">Supplier</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <v-select autocomplete :options="data_option_people_name" v-model="personId"
                          @input="getBillingAndDeliveryAddressList(true);" />
                      </div>
                    </div>
                  </div>
                  <div class="w-full mt-2">
                    <div style="font-size:85%">Billing Address</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <v-select :options="data_option_billing_address" v-model="billingAddressId" autocomplete/ :disabled="addressesLoading">
                        <!-- L'operation n'a pas d'adresse liee : on le DIT, au lieu de
                             choisir une adresse quelconque du client a sa place. -->
                        <span v-if="billingAddressUnlinked" class="text-warning text-sm">No billing address is recorded on this operation. The field above is only a suggestion: check it before saving.</span>
                      </div>
                    </div>
                  </div>
                  <div class="w-full mt-2">
                    <div style="font-size:85%">Loading Address</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <v-select :options="data_option_delivery_address" v-model="deliveryAddressId" autocomplete / :disabled="addressesLoading">
                        <!-- L'operation n'a pas d'adresse liee : on le DIT, au lieu de
                             choisir une adresse quelconque du client a sa place. -->
                        <span v-if="deliveryAddressUnlinked" class="text-warning text-sm">No delivery address is recorded on this operation. The field above is only a suggestion: check it before saving.</span>
                      </div>
                    </div>
                  </div>
                  <div class="w-full mt-20" v-if="!operation_data.apv_no">
                    <div class="vx-col md:w-1/2 w-full" style="font-size: 85%">
                      <div style="font-size: 100%">Payment Date (estimate)</div>
                      <vs-input class="w-full mt-0" v-model="operation_data.transport_invoice_due_date" type="date"
                        name="birthday" />
                    </div>
                    <div class="vx-col md:w-1/2 w-full" style="font-size: 85%" v-if="!operation_data.apv_no">
                      <div style="font-size: 100%">Payment Status</div>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <v-select :options="data_option_payment_status" v-model="statusId" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <template>
                <div id="data-list-list-view" class="data-list-container">
                  <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar"
                    :data="sidebarData" />

                  <vs-table ref="table" :data="products">
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                      <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                        <!-- ACTION - DROPDOWN -->

                        <!-- ADD NEW -->
                        <div
                          class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                          @click="addNewData">
                          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                          <span class="ml-2 text-base text-primary">Add Product</span>
                        </div>
                      </div>
                    </div>

                    <template slot="thead">
                      <vs-th>#</vs-th>
                      <vs-th>Category Product</vs-th>
                      <vs-th>Name</vs-th>
                      <vs-th>Quantity</vs-th>
                      <vs-th>Unit Cost (EUR/UoM)</vs-th>
                      <vs-th>Unit of Measure</vs-th>
                      <vs-th>Volume Unit (m3/UoM)</vs-th>
                      <vs-th>Volume Total (m3)</vs-th>
                      <vs-th>Price per m3 (EUR/m3)</vs-th>
                      <vs-th>Total Cost (EUR)</vs-th>
                      <vs-th>Action</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(    tr, indextr    ) in     data    ">
                          <vs-td>
                            <p class="font-medium truncate">{{ indextr + 1 }}</p>
                          </vs-td>

                          <vs-td>
                            <p class="font-medium truncate">{{ tr.productcategory.name_en }}</p>
                          </vs-td>

                          <vs-td>
                            <p>{{ tr.name_en }}</p>
                          </vs-td>

                          <vs-td>
                            <p>{{ parseFloat(tr.operations_products.quantity).toFixed(4) }}</p>
                          </vs-td>

                          <vs-td>
                            <p v-if="tr.operations_products.idproduct <= -1">-{{
                              Math.abs(tr.operations_products.unit_price).toFixed(4) }}</p>
                            <p v-else>{{ Math.abs(tr.operations_products.unit_price).toFixed(4) }}</p>

                          </vs-td>

                          <vs-td>{{ tr.uomsreference.name_en }}</vs-td>

                          <vs-td>
                            <p v-if="tr.volume">{{ Math.abs(tr.volume).toFixed(4) }}</p>
                          </vs-td>
                          <vs-td>
                            <p v-if="tr.volume">{{ Math.abs(tr.volume * tr.operations_products.quantity).toFixed(4) }}</p>
                          </vs-td>
                          <vs-td>
                            <p v-if="tr.volume">
                              {{
                                Math.abs(
                                  (tr.operations_products.quantity *
                                    tr.operations_products.unit_price) / (tr.volume * tr.operations_products.quantity)
                                ).toFixed(4)
                              }}
                            </p>
                          </vs-td>
                          <vs-td>
                            <p v-if="tr.operations_products.idproduct <= -1">-{{
                              Math.abs(tr.operations_products.quantity * tr.operations_products.unit_price).toFixed(4) }}
                            </p>
                            <p v-else>{{
                              Math.abs(tr.operations_products.quantity * tr.operations_products.unit_price).toFixed(4) }}
                            </p>
                          </vs-td>
                          <vs-td class="whitespace-no-wrap">
                            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                              @click.stop=" editData(tr)" />
                            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                              class="ml-2" @click.stop=" deleteProduct(tr.id, tr.name)" />
                          </vs-td>
                        </vs-tr>
                      </tbody>
                    </template>
                  </vs-table>
                </div>
              </template>
              <!-- Save & Reset Button -->
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button v-if="operation_data.isactive && displayExport != false" type="border" color="danger"
                      icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Disable</vs-button>
                    <vs-button v-else type="border" color="success" icon-pack="feather" icon="icon-trash"
                      @click="confirmEnableRecord">Enable</vs-button>&nbsp;&nbsp;
                    <vs-button class="ml-auto" color="success" @click="save_changes" :disabled="!validateForm || addressesLoading">Save
                      Changes</vs-button>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import DataViewSidebar from "./DataViewSidebar.vue";
import vSelect from "vue-select";
import axios from "@/axios.js";
import { takePersonOption } from "@/helpers/personOption";
import Datepicker from "vuejs-datepicker";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import addressSelection from "@/mixins/addressSelection";
import moment from "moment";

export default {
  mixins: [addressSelection],
  components: {
    DataViewSidebar,
    vSelect,
    Datepicker
  },
  data() {
    return {
      statusId: null,
      counterDanger: null,
      operation_data: null,
      product_data: null,
      data_option_people_name: [],
      //operation_data: JSON.parse(JSON.stringify(this.data)),
      selected: [],
      //itemsPerPage: 1000,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      data_option_payment_status: [],
      sidebarData: {},
      buttonSubmitOpen: false,
      state: {},
      personId: null,
      producttodelete: null,
      data_option_billing_address: [],
      data_option_delivery_address: [],
      billingAddressId: null,
      deliveryAddressId: null,
      statusId: null,
      displayExport: false
    };
  },
  computed: {
    products() {
      return this.$store.state.operationList.operationproducts;
    },
    validateForm() {
      return !this.errors.any();
    },
    currentPage() {
      if (this.isMounted) {
        if (this.operation_data.id) return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      if (this.operation_data.id)
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.users.length;
    }
  },
  methods: {
    async getPaymentStatus() {
      axios.get("/salestatus/data").then((response) => {
        this.data_option_payment_status = [...response.data];
        if (this.operation_data.salestatus) {
          const ItemIndex = this.data_option_payment_status.findIndex(
            (p) => p.value === this.operation_data.salestatus.id
          );
          this.statusId = this.data_option_payment_status.splice(ItemIndex, 1);
        } else {
          this.statusId = this.data_option_payment_status.splice(2, 1);
        }
      });
    },
    // Les deux listes d'options d'abord (Promise.all), la selection ENSUITE.
    // Avant, la resolution de la selection etait lancee depuis chacun des deux
    // .then() : quatre requetes concurrentes, et la premiere tournait contre une
    // liste d'options encore vide. Deux vagues, un seul ordre possible.
    //
    // `personChanged` = le contact vient d'etre change dans le v-select. On ne
    // relit alors PAS l'adresse liee a l'operation : elle appartient encore a
    // l'ANCIEN contact, et la reinjecter dans les options du nouveau est
    // exactement le « l'adresse a saute » signale. On propose l'adresse par
    // defaut du nouveau contact, visible dans le v-select avant tout Save.
    async getBillingAndDeliveryAddressList(personChanged = false) {
      this.billingAddressId = null;
      this.deliveryAddressId = null;
      this.billingAddressUnlinked = false;
      this.deliveryAddressUnlinked = false;
      this._beginAddressLoading();
      // Sans contact, il n'y a pas d'adresse a charger : ne pas dereferencer
      // this.personId.value (TypeError silencieux qui laissait le drapeau de
      // chargement a vrai, donc le bouton Save grise pour toujours).
      if (!this.personId || this.personId.value === null || this.personId.value === undefined) {
        this.data_option_billing_address = [];
        this.data_option_delivery_address = [];
        this._endAddressLoading();
        return;
      }
      try {
        const [billing, delivery] = await Promise.all([
          axios.get("/person/getaddressbilling/" + this.personId.value).catch(() => ({ data: [] })),
          axios.get("/person/getaddressdelivery/" + this.personId.value).catch(() => ({ data: [] })),
        ]);
        this.data_option_billing_address = [...((billing && billing.data) || [])];
        this.data_option_delivery_address = [...((delivery && delivery.data) || [])];
        await this.getSelectedBillingAndDeliveryAddressList(personChanged);
      } finally {
        this._endAddressLoading();
      }
    },
    // `personChanged` : voir getBillingAndDeliveryAddressList. Les deux
    // chaines sont RENVOYEES, donc reellement attendues par l'appelant —
    // avant, elles partaient en fire-and-forget et le drapeau de chargement
    // retombait a faux alors que les adresses n'etaient pas encore resolues.
    async getSelectedBillingAndDeliveryAddressList(personChanged = false) {
      const billingChain = (personChanged
          ? Promise.reject(new Error("contact changed: no linked address to re-read"))
          : axios.get("/person/getaddressbilling/" + this.personId.value + "/" + this.$route.params.userId))
          .then((response) => {
            // The address this operation is actually linked to. pickAddressOption
            // injects it when it is missing from the options instead of silently
            // selecting options[0] — which was then saved over the real address.
            const selectedAddress = response.data[0];
            if (!selectedAddress || selectedAddress.value == null)
              throw new Error("no address linked to this operation");
            this.billingAddressId = this.pickAddressOption(this.data_option_billing_address, selectedAddress);
            this.billingAddressUnlinked = false;

          })
          .catch((error) => {
            // Ne l'annoncer que quand c'est VRAI : un echec reseau tombe dans ce
            // meme catch, et dire alors « aucune adresse enregistree » serait faux.
            this.billingAddressUnlinked = /no address linked|contact changed/.test(
              (error && error.message) || "");
            if (!this.billingAddressId) this.billingAddressId = this.proposeAddressOption(this.data_option_billing_address);
          }
          );

      const deliveryChain = (personChanged
          ? Promise.reject(new Error("contact changed: no linked address to re-read"))
          : axios.get("/person/getaddressdelivery/" + this.personId.value + "/" + this.$route.params.userId))
          .then((response) => {

            // The address this operation is actually linked to. pickAddressOption
            // injects it when it is missing from the options instead of silently
            // selecting options[0] — which was then saved over the real address.
            const selectedAddress = response.data[0];
            if (!selectedAddress || selectedAddress.value == null)
              throw new Error("no address linked to this operation");
            this.deliveryAddressId = this.pickAddressOption(this.data_option_delivery_address, selectedAddress);
            this.deliveryAddressUnlinked = false;
          }).catch((error) => {
            // Ne l'annoncer que quand c'est VRAI : un echec reseau tombe dans ce
            // meme catch, et dire alors « aucune adresse enregistree » serait faux.
            this.deliveryAddressUnlinked = /no address linked|contact changed/.test(
              (error && error.message) || "");
            if (!this.deliveryAddressId) this.deliveryAddressId = this.proposeAddressOption(this.data_option_delivery_address);
          }
          );

      return Promise.all([billingChain, deliveryChain]);
    },
    async getPeople() {
      axios.get("/people_name/data").then(response => {
        this.data_option_people_name = [...response.data];
        // Le contact du document, même inactif — jamais le dernier de la liste (helpers/personOption).
        this.personId = takePersonOption(this.data_option_people_name, this.operation_data.people[0]);
        this.getBillingAndDeliveryAddressList();
      });
    },
    confirmDeleteRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Disable",
        text: `You are about to disable ${namealert}`,
        accept: this.deleteRecord,
        acceptText: "Disable"
      });
    },
    confirmEnableRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirm Enable",
        text: `You are about to re-enable ${namealert}`,
        accept: this.enableRecord,
        acceptText: "Enable"
      });
    },
    enableRecord() {
      axios
        .post("/operation/enable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/reception/" + this.operation_data.id });
      this.showEnableSuccess();
    },
    // Les .catch vides (et les `reject(error)` sur un identifiant inexistant)
    // masquaient tout echec : l'ecran annoncait le succes quand meme.
    showActionFailed(err) {
      console.error("operation enable/disable:", err);
      const data = err && err.response && err.response.data;
      this.$vs.notify({
        color: "danger",
        title: "Action NOT applied",
        text: (data && (data.message || data.error)) || (err && err.message) ||
          "The server refused the operation. Reload the page to see its real state.",
        time: 12000,
      });
    },
    showEnableSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Enable",
        text: "The selected operation was successfully enabled"
      });
    },
    deleteRecord() {
      axios
        .post("/operation/disable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/reception/" + this.operation_data.id });
      this.showDeleteSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Deleted",
        text: "The selected operation was successfully deleted"
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    addNewData() {
      if (this.operation_data.id) {
        var idoperation = this.operation_data.id;
        this.sidebarData = { idoperation };
        this.toggleDataSidebar(true);
      }
    },
    save_changes() {
      // Un enregistrement lance pendant le chargement des adresses partait avec
      // une adresse nulle — ou pire, celle de l'ANCIEN contact.
      const addressBlocked = this.addressSaveBlockReason();
      if (addressBlocked) {
        this.$vs.notify({ color: "warning", title: "Please wait", text: addressBlocked });
        return;
      }
      /* eslint-disable */

      if (parseFloat(this.operation_data.transport_tonaj) > 99.0) {

        this.$vs.notify({
          color: "warning",
          title: "Weight > 99 tons",
          text: "The weight is in tons!"
        });
        return;
      }
      let _idbilling = null
      if (this.billingAddressId) {
        _idbilling = this.billingAddressId.value
      }
      let _iddelivery = null
      if (this.deliveryAddressId) {
        _iddelivery = this.deliveryAddressId.value
      }
      let statusIdStr = null
      {
        if (this.statusId && this.statusId.value) statusIdStr = this.statusId.value
      }

      let isharvestingover = null
      if (this.operation_data.apv_no) {
        if (this.operation_data.isharvestingover) isharvestingover = 'TRUE'
        else isharvestingover = 'FALSE'
      }

      let isapvprivate = null
      if (this.operation_data.apv_no) {
        if (this.operation_data.isapvprivate) isapvprivate = 'TRUE'
        else isapvprivate = 'FALSE'
      }
      

      let apv_guaranteez = '0.00'
      if (this.operation_data.apv_no) {
        if (this.operation_data.apv_guarantee) apv_guaranteez = this.operation_data.apv_guarantee
        else apv_guaranteez = '0.00'
      }
      const obj = {
        id: this.operation_data.id,
        idsalestatus: statusIdStr,
        idperson: this.personId.value,
        date: moment(this.operation_data.date),
        transport_invoice_due_date: moment(this.operation_data.transport_invoice_due_date),
        iddelivery: _iddelivery,
        idbilling: _idbilling,
        invoice_no: this.operation_data.invoice_no,
        apv_no: this.operation_data.apv_no,
        partida: this.operation_data.partida,
        mail_top: this.operation_data.mail_top,
        transport_tonaj: this.operation_data.transport_tonaj,
        isharvestingover: this.operation_data.isharvestingover,
        apv_guarantee: apv_guaranteez,
        isapvprivate: isapvprivate
      };
      if (this.operation_data.id) {
        this.$store
          .dispatch("operationList/updateOperation", obj)
          .catch(err => {
            console.error(err);
          });
        if (this.operation_data.apv_no) this.$router.push({ path: "/dashboard/harvesting" });
        else this.$router.push({ path: "/reception/" + this.operation_data.id });

        this.$vs.notify({
          color: "success",
          title: "Operation Updated!",
          text: "The operation was successfully updated"
        });
      }
    },
    showDeleteAddressSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Product Deleted",
        text: "The Product was successfully deleted"
      });
    },
    deleteProductOne() {
      /*alert("idaddress"+this.addresstodelete)
      alert("idperson"+this.operation_data.id)*/
      const obj = {
        idproduct: this.producttodelete,
        idoperation: this.operation_data.id
      };
      if (!moduleOperationList.isRegistered) {
        this.$store.registerModule("operationList", moduleOperationList);
        moduleOperationList.isRegistered = true;
      }
      this.$store.dispatch("operationList/removeItem", obj).catch(err => {
        console.error(err);
      });
      //refresh view after delete
      this.$store
        .dispatch("operationList/fetchm3difference", this.$route.params.userId)
        .then(res => {
          //this.m3difference = res;
          //console.log(this.$store.state.operationList.m3difference)
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }
          console.error(err);
        });
      this.showDeleteAddressSuccess();
    },
    deleteProduct(id, name) {
      this.producttodelete = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete the product ${name}`,
        accept: this.deleteProductOne,
        acceptText: "Delete Product"
      });
    },
    editData(data) {
      /* this.$store.dispatch('operationList/updateOperation', obj).catch(err => { console.error(err) })*/
      data.idperson = this.operation_data.id;
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getActiveColors(status) {
      if (status === "true") return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    fetch_operation_data(userId) {
      if (userId) {
        this.$store
          .dispatch("operationList/fetchOperation", userId)
          .then(res => {
            this.operation_data = res.data;
            this.getPeople();
            this.getPaymentStatus();
          })
          .catch(err => {
            if (err.response.status === 404) {
              this.user_not_found = true;
              return;
            }
            console.error(err);
          });
      } else {
        this.operation_data = {};
      }
    },
    fetch_product_data(userId) {
      if (userId) {
        this.$store.dispatch("operationList/fetchOperationProducts", userId);
      } else {
        this.product_data = {};
      }
    }
  },

  created() {
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }
    this.fetch_operation_data(this.$route.params.userId);
    this.fetch_product_data(this.$route.params.userId);
    if (localStorage.getItem('login-roles').toLowerCase().includes("admin")) {
      this.displayExport = true
    }
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

